export default __webpack_public_path__ + "static/1440-a491bf9142308de635b2a87c94d19ae6.gif";